// src/api.js
// ce fichier permet d'etablir la connexion avec l'API Express
// et d'exporter les fonctions pour l'utiliser dans le reste de l'application
// Assurez-vous d'avoir installé axios avec `npm install axios`
// Assurez-vous que le serveur Express est en cours d'exécution sur le port spécifié
// Assurez-vous que le serveur Express est configuré pour accepter les requêtes CORS
// Assurez-vous que le serveur Express est configuré pour accepter les cookies
// Assurez-vous que le serveur Express est configuré pour accepter les requêtes avecCredentials
// Assurez-vous que le serveur Express est configuré pour accepter les requêtes POST
// Assurez-vous que le serveur Express est configuré pour accepter les requêtes JSON
// Assurez-vous que le serveur Express est configuré pour accepter les requêtes avec des données
import axios from "axios";

export const API = axios.create({
  baseURL: "https://boutiqu.transfoafricainc.com/api", // Modifie selon ton port Express
  withCredentials: true,
});

export const registerUser = (data) => API.post("/auth/register", data);
export const loginUser = (data) => API.post("/auth/login", data);
//admin@gmail.com
//Password123
